/**
 * Bookings with no client invoice (Fan, 2026-10-15: revenue = client
 * invoices ex VAT by due date, so it matches the Cashflow Invoiced bar
 * exactly). A booking nobody has invoiced is not revenue; it is listed here
 * so the gap stays visible. Values from the API `not_invoiced` block (GBP).
 *
 * Fan, 2026-10-24: a plain table under Currency Mix, same look as Currency
 * Mix, not a card near the top of the page.
 */
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import {
  Table, TableBody, TableCell, TableHead, TableHeader, TableRow,
} from '../ui/table';
import { formatCurrency } from '../../lib/utils';

export function NotInvoicedCard(props) {
  var n = props.notInvoiced;
  var cx = props.cx;
  var dc = props.dc;
  if (!n || !n.count) return null;
  var fmt = function (v) { return formatCurrency(cx(v), dc); };
  return (
    <Card data-testid="not-invoiced-card">
      <CardHeader>
        <CardTitle className="text-base">Not Invoiced</CardTitle>
        <p className="text-xs text-muted-foreground mt-0.5">
          Delivered stays with no client invoice in BR OS, ex VAT. Not in revenue until invoiced.
        </p>
      </CardHeader>
      <CardContent>
        <div className="overflow-x-auto">
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>Booking</TableHead>
                <TableHead>Client</TableHead>
                <TableHead>Stay</TableHead>
                <TableHead className="text-right">{'Value (' + dc + ')'}</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody data-testid="not-invoiced-bookings">
              {(n.bookings || []).map(function (b) {
                return (
                  <TableRow key={b.booking_id}>
                    <TableCell className="font-mono text-xs">{b.booking_id}</TableCell>
                    <TableCell>{b.company || ''}</TableCell>
                    <TableCell className="text-xs">{b.check_in ? b.check_in + ' to ' + (b.check_out || '') : ''}</TableCell>
                    <TableCell className="text-right font-mono">{fmt(parseFloat(b.turnover || 0))}</TableCell>
                  </TableRow>
                );
              })}
              <TableRow className="font-semibold">
                <TableCell>{'Total (' + n.count + ' booking' + (n.count === 1 ? '' : 's') + ')'}</TableCell>
                <TableCell></TableCell>
                <TableCell></TableCell>
                <TableCell className="text-right font-mono">{fmt(parseFloat(n.turnover || 0))}</TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </div>
      </CardContent>
    </Card>
  );
}
